import Grid from '../components/grid'
import Container from '../components/ui/container'
import DisclosureDefault from '../components/ui/disclosure-default'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { RichText } from '../v2/components/RichText'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'faq-tooltips' }>

function FAQTooltips(block: BlockProps): ReactElement {
  const { questions } = block

  return (
    <Container>
      <Grid className="">
        {questions &&
          questions.map((question, i) => {
            return (
              <DisclosureDefault
                key={`question--map--${question?.id || i}`}
                className="col-span-full lg:col-span-6"
                open={question.isOpen}
                title={question.question}
              >
                <RichText className="text-black font-content" content={question?.answer} />
              </DisclosureDefault>
            )
          })}
      </Grid>
    </Container>
  )
}

export default FAQTooltips
